var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-plant", {
                  attrs: { type: "none" },
                  on: { datachange: _vm.getList },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-datepicker", {
                  attrs: {
                    label: "대상년도",
                    type: "year",
                    default: "today",
                    name: "uninjuryYear",
                  },
                  on: { datachange: _vm.getList },
                  model: {
                    value: _vm.searchParam.uninjuryYear,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "uninjuryYear", $$v)
                    },
                    expression: "searchParam.uninjuryYear",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-text", {
                  attrs: {
                    editable: false,
                    label: "인원기준일",
                    name: "standardDate",
                  },
                  model: {
                    value: _vm.data.standardDate,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "standardDate", $$v)
                    },
                    expression: "data.standardDate",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-text", {
                  attrs: {
                    editable: false,
                    label: "평균인원(생산직접부서)",
                    name: "avgCnt",
                  },
                  model: {
                    value: _vm.data.avgCnt,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "avgCnt", $$v)
                    },
                    expression: "data.avgCnt",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _vm.editable
                  ? _c("c-btn", {
                      staticClass: "uninjury-addyear",
                      attrs: { label: "신규년도 추가", icon: "add" },
                      on: { btnClicked: _vm.addYear },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: _vm.searchParam.uninjuryYear + "년도 무재해 추진운동",
            tableId: "table",
            merge: _vm.grid.merge,
            columns: _vm.grid.columns,
            data: _vm.data.deptUninjurys,
            filtering: false,
            columnSetting: false,
            usePaging: false,
            rowKey: "deptCd",
            selection: "single",
          },
          on: {
            "table-data-change": _vm.tableDataChange,
            linkClick: _vm.linkClick,
          },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  col.name === "successFlag"
                    ? [
                        _vm.chgTargetStatus(props.row)
                          ? _c(
                              "q-chip",
                              {
                                attrs: {
                                  outline: "",
                                  square: "",
                                  color: "red",
                                  "text-color": "white",
                                },
                              },
                              [_vm._v(" 목표초과 ")]
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable && _vm.data.deptUninjurys.length > 0
                    ? _c("c-btn", {
                        attrs: {
                          label: "무재해 달성등록",
                          color: "green",
                          icon: "autorenew",
                        },
                        on: { btnClicked: _vm.endUninjury },
                      })
                    : _vm._e(),
                  _vm.editable && _vm.data.deptUninjurys.length > 0
                    ? _c("c-btn", {
                        attrs: {
                          label: "등록사고 적용",
                          color: "red",
                          icon: "check",
                        },
                        on: { btnClicked: _vm.changeAccident },
                      })
                    : _vm._e(),
                  _vm.editable && _vm.data.deptUninjurys.length > 0
                    ? _c("c-btn", {
                        attrs: { label: "LBLSAVE", icon: "save" },
                        on: { btnClicked: _vm.saveDept },
                      })
                    : _vm._e(),
                  _c("c-btn", {
                    attrs: { label: "LBLSEARCH", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }